import React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Inline } from '@/components/admin/atoms/layout/Inline'
import { Text } from '@/components/admin/atoms/typography/Text'
import { PaginationButton } from '@/components/admin/atoms/actions/PaginationButton'
import { usePaginationVM } from './Pagination.vm'
import type { PaginationMeta } from '@/types/shared'

interface PaginationProps {
  meta: PaginationMeta
  onPageChange: (page: number) => void
  className?: never
}

export const Pagination: React.FC<PaginationProps> = ({ meta, onPageChange }) => {
  const vm = usePaginationVM(meta)

  if (!vm.shouldRender) return null

  return (
    <Inline gap="4" align="center" justify="between">
      <Text size="sm" color="muted">
        Showing {vm.from}–{vm.to} of {vm.totalCount}
      </Text>
      <Inline gap="1">
        <PaginationButton
          onClick={() => onPageChange(vm.previousPage)}
          disabled={!vm.hasPrevious}
        >
          <ChevronLeft style={{ width: 16, height: 16 }} />
        </PaginationButton>
        {vm.pages.map((page) => (
          <PaginationButton
            key={page}
            onClick={() => onPageChange(page)}
            active={page === vm.currentPage}
          >
            {page}
          </PaginationButton>
        ))}
        <PaginationButton
          onClick={() => onPageChange(vm.nextPage)}
          disabled={!vm.hasNext}
        >
          <ChevronRight style={{ width: 16, height: 16 }} />
        </PaginationButton>
      </Inline>
    </Inline>
  )
}
